import { render } from "./CongressDetail.vue?vue&type=template&id=520772c3"
import script from "./CongressDetail.vue?vue&type=script&lang=js"
export * from "./CongressDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__